<template>
  <div>

    <default-rate-field
      v-model="defaultRate"
      :show-id="showIds"
      :collapsible="collapsible"
      v-model:collapsed="isCollapsed"
      :density="density"
      :disabled="disabled"
      :hide-details="hideDetails"
    />

    <v-expand-transition group>
      <channel-default-rate-field
        v-if="!isCollapsed"
        v-for="(_, n) in defaultRate.channelDefaultRates.length"
        class="ml-12"
        :class="{'mt-2': hideDetails}"
        :default-cost="defaultRate.defaultCost"
        v-model="defaultRate.channelDefaultRates[n]"
        :show-id="showIds"
        :density="density"
        :disabled="disabled"
        :hide-details="hideDetails"
      />
    </v-expand-transition>

  </div>
</template>

<script setup lang="ts">

import DefaultRateField from './DefaultRateField.vue'
import ChannelDefaultRateField from './ChannelDefaultRateField.vue'
import type { DefaultRateFieldWithCdrsState } from '../../../types/misc'
import { ref } from 'vue'

interface Props {
  showIds?: boolean
  disabled?: boolean
  collapsible?: boolean
  collapsed?: boolean
  density?: null | 'compact' | 'default' | 'comfortable'
  hideDetails?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  showIds: false,
  disabled: false,
  collapsible: true,
  collapsed: true,
  density: 'default',
  hideDetails: false,
})

const defaultRate = defineModel<DefaultRateFieldWithCdrsState>({required: true})
const isCollapsed = ref<boolean>(props.collapsed)

</script>
